export const NEW_CATEGORY = {
  id: null,
  parent_id: null,
  name: '',
  children: []
}